import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "../styles/PreBook.css";

export default function PreBook() {
  const location = useLocation();
  const navigate = useNavigate();
  const cart = location.state?.cart || [];

  const [form, setForm] = useState({
    name: "",
    phone: "",
    address: "",
    landmark: "",
    pincode: "",
  });

  const [success, setSuccess] = useState(false);
  const [orderId, setOrderId] = useState("");

  // ================================
  // ✅ SHIPPING LOGIC (UNCHANGED CORE)
  // ================================

  const itemsTotal = cart.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  let shipping = Math.max(...cart.map((i) => i.shipping || 0), 0);

  const totalQty = cart.reduce(
    (acc, item) => acc + item.quantity,
    0
  );

  if (totalQty >= 2 && totalQty <= 5) {
    shipping = shipping * 1.5;
  } else if (totalQty > 5) {
    shipping = shipping * 2;
  }

  const totalAmount = itemsTotal + shipping;

  // ================================
  // INPUT HANDLER
  // ================================
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ================================
  // ORDER SUBMIT
  // ================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !form.name ||
      !form.phone ||
      !form.address ||
      !form.landmark ||
      !form.pincode
    ) {
      alert("Please fill all details");
      return;
    }

    const newOrderId = "ORD" + Date.now();

    // SAVE TO FIREBASE
    await addDoc(collection(db, "prebookings"), {
      orderId: newOrderId,
      name: form.name,
      phone: form.phone,
      address: form.address,
      landmark: form.landmark,
      pincode: form.pincode,
      cartItems: cart,
      totalAmount,
      status: "Pending",
      createdAt: serverTimestamp(),
    });

    // WHATSAPP MESSAGE
    const productList = cart
      .map(
        (item) =>
          `• ${item.name} (x${item.quantity}) - ₹${
            item.price * item.quantity
          }`
      )
      .join("\n");

    const message = `🛒 *New Order Received*

📦 Order ID: ${newOrderId}

👤 Name: ${form.name}
📞 Phone: ${form.phone}

📍 Address: ${form.address}
🏷 Landmark: ${form.landmark}
📮 Pincode: ${form.pincode}

🛍 Products:
${productList}

💰 Subtotal: ₹${itemsTotal}
🚚 Shipping: ₹${shipping}

✅ Total: ₹${totalAmount}`;

    const whatsappURL = `https://wa.me/919363966702?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");

    // SUCCESS FLOW (UNCHANGED)
    setOrderId(newOrderId);
    setSuccess(true);
  };

  // ================================
  // REDIRECT AFTER SUCCESS
  // ================================
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, [success, navigate]);

  // ================================
  // SUCCESS UI
  // ================================
  if (success) {
    return (
      <div className="success-container">
        <div className="success-box">
          <h2>🎉 Order Placed Successfully!</h2>

          <p>Your Order ID:</p>
          <h3>{orderId}</h3>

          <p>Total Paid: ₹{totalAmount}</p>

          <p>Redirecting to home...</p>
        </div>
      </div>
    );
  }

  // ================================
  // MAIN UI
  // ================================
  return (
    <div className="prebook-container">
      <h2 className="title">Order Product</h2>

      {/* ORDER SUMMARY */}
      <div className="order-summary">
        {cart.map((item, index) => (
          <div key={index} className="summary-item">
            <p><strong>{item.name}</strong></p>
            <p>Qty: {item.quantity}</p>
            <p>Price: ₹{item.price}</p>
          </div>
        ))}

        {/* ✅ FIXED: SHIPPING ONLY ONCE */}
        <h3>Subtotal: ₹{itemsTotal}</h3>
        <p>Shipping: ₹{shipping}</p>
        <h2 className="total">Total: ₹{totalAmount}</h2>
      </div>

      {/* FORM */}
      <form className="order-form" onSubmit={handleSubmit}>
        <label>Name *</label>
        <input
          name="name"
          placeholder="Enter name"
          value={form.name}
          onChange={handleChange}
        />

        <label>Phone *</label>
        <input
          name="phone"
          placeholder="Enter phone"
          value={form.phone}
          onChange={handleChange}
        />

        <label>Address *</label>
        <textarea
          name="address"
          placeholder="Enter address"
          value={form.address}
          onChange={handleChange}
        />

        <label>Landmark *</label>
        <input
          name="landmark"
          placeholder="Near landmark"
          value={form.landmark}
          onChange={handleChange}
        />

        <label>Pincode *</label>
        <input
          name="pincode"
          placeholder="Enter pincode"
          value={form.pincode}
          onChange={handleChange}
        />

        <button type="submit">Order Now</button>
      </form>
    </div>
  );
}